import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { ShipmentTabKey } from '../../models/shipments/shipment-tab.interface';

const validTabKeys: ShipmentTabKey[] = [
  'all',
  'pickup',
  'inTransit',
  'delivered',
  'heatMap'
];

function isShipmentTabKey(value: string | null): value is ShipmentTabKey {
  return !!value && (validTabKeys as string[]).includes(value);
}

// The `tab` query param is the source of truth for tab selection (no store) -
// this hook reads/validates it and writes it back while preserving
// location.state, since setSearchParams doesn't carry that forward on its
// own and losing it would blank the breadcrumb on the first tab click.
export function useShipmentTabParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const rawTab = searchParams.get('tab');
  const activeTab: ShipmentTabKey = isShipmentTabKey(rawTab) ? rawTab : 'all';

  const setActiveTab = useCallback(
    (tab: ShipmentTabKey) => {
      const next = new URLSearchParams(searchParams);
      next.set('tab', tab);
      setSearchParams(next, { state: location.state });
    },
    [searchParams, setSearchParams, location.state]
  );

  return { activeTab, setActiveTab };
}

export default useShipmentTabParam;
